<template>
  <div>
    <b-dropdown
        variant="link"
        toggle-class="text-decoration-none"
        menu-class="p-0 m-0"
        no-caret :disabled="disabled">
      <template #button-content>
        <b-badge :variant="getStatusVariant()">{{ getStatusTexte() }}</b-badge>
      </template>
      <b-dropdown-item
          v-for="s in tOptions"
          :key="s.value"
          :variant="s.variant"
          @click="$emit('input',s.value)">
        {{ s.text }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name : "l-status",
  model: {
    prop : "status",
    event: "input"
  },
  props: {
    variant : String,
    status  : [String, Number, Boolean],
    disabled: Boolean,
    options : {
      type: Array,
      default() {
        return []
      },
    }
  },
  data() {
    return {
      tOptions: this.sanitizeOptions(this.options)
    }
  },
  methods: {
    getStatusTexte() {
      if (!this.tOptions.length) return this.status;
      return this.tOptions.find(o => o.value === this.status)?.text
    },
    getStatusVariant() {
      if (!this.tOptions?.length) return this.variant;
      return this.tOptions.find(o => o.value === this.status)?.variant
    },
    sanitizeOptions(options) {
      return options.map(
          o => {
            if (typeof o === 'string') return {text: o, value: o}
            return o
          }
      )

    }
  },
  created() {
  }
}
</script>

<style>
.btn.dropdown-toggle:disabled {
  opacity: 1 !important;
}
</style>